"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CardHeader.default;
  }
});

var _CardHeader = _interopRequireDefault(require("./CardHeader"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/CardHeader/index.js
// module id = 443
// module chunks = 0